import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  portalId: string;
  spaceId: string | number;
  name?: string;
};

const [useDuplicatePortal, duplicatePortal] = createAsyncAction(
  "portals/duplicate",
  async ({ portalId, spaceId, name }: Args) => {
    const res = await API.call<{ portal: string }>({
      endpoint: `/portals/${spaceId}/${portalId}/duplicate`,
      method: "POST",
      data: name ? { name } : undefined,
    });
    return { ...res, result: res.result.portal };
  }
);

export default useDuplicatePortal;
export { duplicatePortal };
